export interface InvestWorkflow {
    Code?: string,
    Libelle?: string,
    Ordre?: number
}

const PROJET: string = "PRJ"
const MONTANT: string = "MON"
const PAIEMENT: string = "PAI"
const SELECT_BRANCH: string = "SBR"

export const InvestWorkflow = {
    PROJET,
    MONTANT,
    PAIEMENT,
    SELECT_BRANCH
}